<template>
  <div>
    <Header state="edit" />
    <CustomCoinForm />
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import CustomCoinForm from '@/components/form/CustomCoinForm';

export default {
  name: 'EditCoin',
  components: {
    Header,
    CustomCoinForm,
  },
};
</script>



// WEBPACK FOOTER //
// src/view/EditCoin.vue